module.exports = require("memory-fs");


//////////////////
// WEBPACK FOOTER
// external "memory-fs"
// module id = 72
// module chunks = 0